import Select from "components/common/Select";
import MultiOptionsSwitch from "components/common/form/MultioptionSwitch";
import { RATING_CATEGORIES, RATING_SUB_CATEGORIES_SIZE } from "core/dataConstants";
import {assertObject, assertString} from "core/validation";
import PropTypes from "prop-types";
import React from "react";

function RatingSubCategorySelect({ value, onChange, options, hasMargin, multiple, width }) {
    const sty = hasMargin ? { marginTop: -16, marginBottom: 0 } : {};
    const optV = multiple ? value :  { value, label: value };
    return (
        <span style={{ width: width, marginLeft: 10, ...sty }}>
            <Select value={optV} styles={sty}
                onChange={onChange}
                multiple={multiple}
                defaultMenuPortalTarget
                options={options} />
        </span>
    );
}

RatingSubCategorySelect.propTypes = {
    onChange: PropTypes.func,
    options: PropTypes.array,
    hasMargin: PropTypes.bool,
};

function RatingCategorySelect({ value, onChange, noneOptionLabel = "NONE" }) {
    const options = React.useMemo(() => {
        return [{ value: null, label: noneOptionLabel }, ...RATING_CATEGORIES];
    }, [noneOptionLabel]);
    return (
        <span style={{ paddingTop: 5 }}>
            <MultiOptionsSwitch
                value={value}
                options={options}
                onChange={onChange}

            />
        </span>
    );
}

RatingCategorySelect.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
};
function getSubCatOptions(category) {
    if (assertObject(category)) {
        const result = [];
        for (let i = 1; i <= RATING_SUB_CATEGORIES_SIZE; i++) {
            const str = `${category}-${i}`;
            result.push({ label: str, value: str });
        }
        return result;
    } else return [];
}

export function getNumberFromSub(subCategory) {
    if(assertString(subCategory)) {
        const sp = subCategory.split("-");
        return {
            category: sp[0],
            subCategory: sp[1],
        };
    }
    return null;
}
function RatingCategoryComponent({ category, subCategory, onChange, hasMargin, width = 150, multiple, noneOptionLabel }) {
    const [catValue, setCatValue] = React.useState(category);
    const [subCatValue, setSubCatValue] = React.useState(multiple);

    React.useEffect(() => {
        if (category !== catValue) {
            setCatValue(category);
            setSubCatValue(null);
        }
    }, [catValue, category]);

    React.useEffect(() => {
        if (subCategory !== subCatValue) {
            setSubCatValue(subCategory);
        }
    }, [subCatValue, subCategory]);

    function handleChangeCat(value) {
        setCatValue(value);
        const subCat = multiple ? [] : null;
        setSubCatValue(subCat);
        onChange(value, subCat);
    }
    function handleSubCatChange(opt) {
        const value = multiple ?  opt : opt ?  opt.value : null;
        setSubCatValue(value);
        onChange(catValue, value);
    }
    const subCatOptions = React.useMemo(() => {
        return getSubCatOptions(catValue);
    }, [catValue]);

    return (
        <div style={{ display: "inline-flex", minWidth:width }}>
            <RatingCategorySelect value={catValue}
                noneOptionLabel={noneOptionLabel}
                onChange={handleChangeCat} />
            {catValue && <RatingSubCategorySelect
                value={subCatValue}
                hasMargin={hasMargin}
                width={width}
                options={subCatOptions}
                multiple={multiple}
                onChange={handleSubCatChange}
            /> }
        </div>
    );
}

RatingCategoryComponent.propTypes = {
    category: PropTypes.string,
    subCategory: PropTypes.string,
    onChange: PropTypes.func,
    hasMargin: PropTypes.bool,
};

export default RatingCategoryComponent;
